module.exports = __webpack_public_path__ + "static/media/art18.c5fc70b3.jpg";